import {getFiveYears} from 'src/utils'

const getOptions = <T>(p: readonly TOption<T>[]) => p

export const autoCalculatorOptions = getOptions([
	{value: 'true', name: 'On'},
	{value: 'false', name: 'Off'},
] as const)

export const years = getOptions(getFiveYears(new Date().getFullYear()))

export const maritalOptions = getOptions([
	{value: 'SINGLE', name: 'Single'},
	{value: 'MARRIED', name: 'Married'},
	{value: 'HEAD_OF_HOUSEHOLD', name: 'Head of household'},
] as const)
